import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac1a45cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","margin-top":"10rem"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/myinvois/images/Error Page Image.png",
  alt: "Logo",
  style: {"width":"40rem","margin":"1rem"}
}, null, -1 /* HOISTED */))
const _hoisted_3 = { class: "error-box" }
const _hoisted_4 = { style: {"margin-bottom":"0"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_6 = { style: {"font-weight":"bold"} }
const _hoisted_7 = ["href"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "header-container" }
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("Complete Details for "),
  /*#__PURE__*/_createElementVNode("br", { class: "mobile-next" }),
  /*#__PURE__*/_createTextVNode(" E-Invoicing Compliances ")
], -1 /* HOISTED */))
const _hoisted_12 = { class: "form-container" }
const _hoisted_13 = {
  key: 0,
  style: {"background-color":"#e4e4e4"},
  class: "rounded"
}
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div style=\"display:flex;justify-content:center;margin-top:20px;\" data-v-ac1a45cb><svg width=\"40px\" height=\"40px\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-ac1a45cb><path opacity=\"0.5\" d=\"M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z\" fill=\"#008000\" data-v-ac1a45cb></path><path d=\"M16.0303 8.96967C16.3232 9.26256 16.3232 9.73744 16.0303 10.0303L11.0303 15.0303C10.7374 15.3232 10.2626 15.3232 9.96967 15.0303L7.96967 13.0303C7.67678 12.7374 7.67678 12.2626 7.96967 11.9697C8.26256 11.6768 8.73744 11.6768 9.03033 11.9697L10.5 13.4393L12.7348 11.2045L14.9697 8.96967C15.2626 8.67678 15.7374 8.67678 16.0303 8.96967Z\" fill=\"#ffffff\" data-v-ac1a45cb></path></svg></div><p style=\"text-align:center;font-size:14px;font-weight:bold;justify-content:center;margin:8px;\" data-v-ac1a45cb> Congratulations! Your E-Invoice Info has been successfully submitted. </p>", 2)
const _hoisted_16 = [
  _hoisted_14
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1 /* HOISTED */))
const _hoisted_18 = { style: {"font-size":"18px","font-weight":"bold","color":"black","padding":"1rem 0 0 0"} }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "title-line" }, null, -1 /* HOISTED */))
const _hoisted_22 = {
  key: 0,
  class: "form-group"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "identification_number_type",
  style: {"margin-bottom":"1rem"}
}, [
  /*#__PURE__*/_createTextVNode(" Identification Number Type "),
  /*#__PURE__*/_createElementVNode("span", { class: "mandatory-label" }, " *")
], -1 /* HOISTED */))
const _hoisted_24 = { class: "identification-number-row" }
const _hoisted_25 = ["id", "onUpdate:modelValue", "value", "disabled"]
const _hoisted_26 = ["for", "textContent"]
const _hoisted_27 = {
  key: 1,
  class: "form-group"
}
const _hoisted_28 = ["placeholder", "disabled"]
const _hoisted_29 = { class: "form-error-msg" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = { for: "full_name" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mandatory-label" }, " *", -1 /* HOISTED */))
const _hoisted_36 = ["disabled"]
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = { for: "email" }
const _hoisted_39 = ["textContent"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mandatory-label" }, " *", -1 /* HOISTED */))
const _hoisted_41 = ["placeholder", "disabled"]
const _hoisted_42 = { class: "form-error-msg" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = { for: "contact_number" }
const _hoisted_46 = ["textContent"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mandatory-label" }, " *", -1 /* HOISTED */))
const _hoisted_48 = ["disabled"]
const _hoisted_49 = { class: "form-error-msg" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { class: "form-group" }
const _hoisted_52 = { for: "tax_id" }
const _hoisted_53 = ["textContent"]
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mandatory-label" }, " *", -1 /* HOISTED */))
const _hoisted_55 = ["disabled"]
const _hoisted_56 = { class: "form-error-msg" }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = {
  key: 2,
  class: "form-group"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "roc" }, [
  /*#__PURE__*/_createTextVNode(" New Business Registration No. (ROC) "),
  /*#__PURE__*/_createElementVNode("span", { class: "mandatory-label" }, " *")
], -1 /* HOISTED */))
const _hoisted_60 = ["disabled"]
const _hoisted_61 = { class: "form-error-msg" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = {
  key: 3,
  class: "form-group"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "sst_number" }, [
  /*#__PURE__*/_createTextVNode(" Sales and Services Tax (SST) Registration No. "),
  /*#__PURE__*/_createElementVNode("span", { class: "mandatory-label" }, " (Optional)")
], -1 /* HOISTED */))
const _hoisted_65 = ["disabled"]
const _hoisted_66 = { class: "form-error-msg" }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = {
  key: 4,
  class: "form-group"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "msic_code" }, [
  /*#__PURE__*/_createTextVNode(" MSIC Code "),
  /*#__PURE__*/_createElementVNode("span", { class: "mandatory-label" }, " *")
], -1 /* HOISTED */))
const _hoisted_70 = ["disabled"]
const _hoisted_71 = ["value"]
const _hoisted_72 = {
  key: 5,
  class: "form-group"
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "fax_number" }, [
  /*#__PURE__*/_createTextVNode(" Fax No. "),
  /*#__PURE__*/_createElementVNode("span", { class: "mandatory-label" }, " (Optional)")
], -1 /* HOISTED */))
const _hoisted_74 = ["disabled"]
const _hoisted_75 = {
  key: 6,
  class: "form-group"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "operating_from_time" }, [
  /*#__PURE__*/_createTextVNode(" Operating From Time "),
  /*#__PURE__*/_createElementVNode("span", { class: "mandatory-label" }, " *")
], -1 /* HOISTED */))
const _hoisted_77 = ["disabled"]
const _hoisted_78 = {
  key: 7,
  class: "form-group"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "operating_to_time" }, [
  /*#__PURE__*/_createTextVNode(" Operating To Time "),
  /*#__PURE__*/_createElementVNode("span", { class: "mandatory-label" }, " *")
], -1 /* HOISTED */))
const _hoisted_80 = ["disabled"]
const _hoisted_81 = {
  key: 8,
  style: {"font-size":"18px","font-weight":"bold","color":"black","padding":"1rem 0 0 0"}
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Sales Representative Info", -1 /* HOISTED */))
const _hoisted_83 = [
  _hoisted_82
]
const _hoisted_84 = {
  key: 9,
  class: "title-line"
}
const _hoisted_85 = {
  key: 10,
  class: "form-group"
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "sales_representative" }, [
  /*#__PURE__*/_createTextVNode(" Sales Representative Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "mandatory-label" }, " *")
], -1 /* HOISTED */))
const _hoisted_87 = ["disabled"]
const _hoisted_88 = {
  key: 11,
  class: "form-group"
}
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "sales_representative_email" }, [
  /*#__PURE__*/_createTextVNode(" Sales Representative Email "),
  /*#__PURE__*/_createElementVNode("span", { class: "mandatory-label" }, " *")
], -1 /* HOISTED */))
const _hoisted_90 = ["disabled"]
const _hoisted_91 = { class: "form-error-msg" }
const _hoisted_92 = { key: 0 }
const _hoisted_93 = {
  key: 12,
  class: "form-group"
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "sales_representative_contact_number" }, [
  /*#__PURE__*/_createTextVNode(" Sales Representative Contact No. "),
  /*#__PURE__*/_createElementVNode("span", { class: "mandatory-label" }, " *")
], -1 /* HOISTED */))
const _hoisted_95 = ["disabled"]
const _hoisted_96 = { class: "form-error-msg" }
const _hoisted_97 = { key: 0 }
const _hoisted_98 = {
  key: 13,
  style: {"font-size":"18px","font-weight":"bold","color":"black","padding":"1rem 0 0 0"}
}
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Accounts Receivable Representative Info", -1 /* HOISTED */))
const _hoisted_100 = [
  _hoisted_99
]
const _hoisted_101 = {
  key: 14,
  class: "title-line"
}
const _hoisted_102 = {
  key: 15,
  class: "form-group"
}
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "accounts_receivable_representative" }, [
  /*#__PURE__*/_createTextVNode(" Accounts Receivable Representative Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "mandatory-label" }, " *")
], -1 /* HOISTED */))
const _hoisted_104 = ["disabled"]
const _hoisted_105 = {
  key: 16,
  class: "form-group"
}
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "accounts_receivable_representative_email" }, [
  /*#__PURE__*/_createTextVNode(" Accounts Receivable Representative Email "),
  /*#__PURE__*/_createElementVNode("span", { class: "mandatory-label" }, " *")
], -1 /* HOISTED */))
const _hoisted_107 = ["disabled"]
const _hoisted_108 = { class: "form-error-msg" }
const _hoisted_109 = { key: 0 }
const _hoisted_110 = {
  key: 17,
  class: "form-group"
}
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "accounts_receivable_representative_contact_number" }, [
  /*#__PURE__*/_createTextVNode(" Accounts Receivable Representative Contact No. "),
  /*#__PURE__*/_createElementVNode("span", { class: "mandatory-label" }, " *")
], -1 /* HOISTED */))
const _hoisted_112 = ["disabled"]
const _hoisted_113 = { class: "form-error-msg" }
const _hoisted_114 = { key: 0 }
const _hoisted_115 = { style: {"font-size":"18px","font-weight":"bold","color":"black","padding":"1rem 0 0 0"} }
const _hoisted_116 = ["textContent"]
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "title-line" }, null, -1 /* HOISTED */))
const _hoisted_118 = { class: "form-group" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "address_line_1" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Address Line 1"),
  /*#__PURE__*/_createElementVNode("span", { class: "mandatory-label" }, " *")
], -1 /* HOISTED */))
const _hoisted_120 = ["disabled"]
const _hoisted_121 = { class: "form-group" }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "address_line_2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Address Line 2"),
  /*#__PURE__*/_createElementVNode("span", { class: "mandatory-label" }, " (Optional)")
], -1 /* HOISTED */))
const _hoisted_123 = ["placeholder", "disabled"]
const _hoisted_124 = { class: "form-group" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "postcode" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Postcode"),
  /*#__PURE__*/_createElementVNode("span", { class: "mandatory-label" }, " *")
], -1 /* HOISTED */))
const _hoisted_126 = ["disabled"]
const _hoisted_127 = { class: "form-group" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "country" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Country"),
  /*#__PURE__*/_createElementVNode("span", { class: "mandatory-label" }, " *")
], -1 /* HOISTED */))
const _hoisted_129 = ["disabled"]
const _hoisted_130 = ["value"]
const _hoisted_131 = { class: "form-group" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "state" }, [
  /*#__PURE__*/_createElementVNode("span", null, "State"),
  /*#__PURE__*/_createElementVNode("span", { class: "mandatory-label" }, " *")
], -1 /* HOISTED */))
const _hoisted_133 = ["disabled"]
const _hoisted_134 = ["value"]
const _hoisted_135 = { class: "form-group" }
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "city" }, [
  /*#__PURE__*/_createElementVNode("span", null, "City"),
  /*#__PURE__*/_createElementVNode("span", { class: "mandatory-label" }, " *")
], -1 /* HOISTED */))
const _hoisted_137 = ["disabled"]
const _hoisted_138 = ["disabled"]
const _hoisted_139 = ["value"]
const _hoisted_140 = { key: 2 }
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { disabled: "" }, "Please Choose State First", -1 /* HOISTED */))
const _hoisted_142 = [
  _hoisted_141
]
const _hoisted_143 = { class: "form-actions" }
const _hoisted_144 = ["disabled"]
const _hoisted_145 = { style: {"text-align":"center","margin-top":"2rem","color":"#398bff","font-size":"14px"} }
const _hoisted_146 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($data.error)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, [
            _createTextVNode("Invalid session link."),
            _hoisted_5,
            _createTextVNode("If you have any concern, please contact us at "),
            _createElementVNode("span", _hoisted_6, [
              _createElementVNode("a", {
                href: `mailto:${$data.support_email_address}`
              }, _toDisplayString($data.support_email_address), 9 /* TEXT, PROPS */, _hoisted_7)
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("img", {
            src: $data.logo_file_path,
            alt: "Logo",
            style: {"width":"9rem","margin":"1rem"}
          }, null, 8 /* PROPS */, _hoisted_10),
          _hoisted_11
        ]),
        _createElementVNode("div", _hoisted_12, [
          ($data.is_submitted)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [..._hoisted_16]))
            : _createCommentVNode("v-if", true),
          _hoisted_17,
          _createElementVNode("form", {
            onSubmit: _cache[26] || (_cache[26] = _withModifiers((...args) => ($options.submit_form && $options.submit_form(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_18, [
              ($data.claim_as === 'Company')
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, "COMPANY DETAILS"))
                : (_openBlock(), _createElementBlock("span", _hoisted_20, "INDIVIDUAL DETAILS"))
            ]),
            _hoisted_21,
            _createCommentVNode(" NRIC and Name fields for Individual "),
            ($data.claim_as === 'Individual')
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.identification_number_type_options, (identification_number_type) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: identification_number_type,
                        class: "form-check"
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: identification_number_type,
                          "onUpdate:modelValue": $event => (($data.formData.identification_number_type) = $event),
                          value: identification_number_type,
                          required: "",
                          disabled: $data.is_submitted
                        }, null, 8 /* PROPS */, _hoisted_25), [
                          [_vModelRadio, $data.formData.identification_number_type]
                        ]),
                        _createElementVNode("label", {
                          for: identification_number_type,
                          textContent: _toDisplayString(identification_number_type),
                          style: {"margin":"0 1rem 0 0"}
                        }, null, 8 /* PROPS */, _hoisted_26)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            ($data.claim_as === 'Individual')
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    pattern: "[0-9]*",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.formData.identification_number) = $event)),
                    id: "identification_number",
                    placeholder: $options.get_identification_number_placeholder,
                    required: "",
                    onKeydown: _cache[1] || (_cache[1] = (...args) => ($options.handleKeydown && $options.handleKeydown(...args))),
                    onInput: _cache[2] || (_cache[2] = (...args) => ($options.handleInput && $options.handleInput(...args))),
                    disabled: $data.is_submitted
                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_28), [
                    [_vModelText, $data.formData.identification_number]
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    ($data.form_error_data.identification_number)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString($data.form_error_data.identification_number), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("label", _hoisted_32, [
                ($data.claim_as === 'Company')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, "Company Name"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_34, "Full Name (as per ID)")),
                _hoisted_35
              ]),
              _createTextVNode(),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.formData.full_name) = $event)),
                disabled: $data.is_submitted
              }, null, 8 /* PROPS */, _hoisted_36), [
                [_vModelText, $data.formData.full_name]
              ])
            ]),
            _createCommentVNode(" Business Email or Email Field "),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("label", _hoisted_38, [
                _createElementVNode("span", {
                  textContent: _toDisplayString($data.claim_as === 'Company' ? 'Company Email Address' : 'Email Address')
                }, null, 8 /* PROPS */, _hoisted_39),
                _hoisted_40
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "email",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.formData.email) = $event)),
                id: "email-field",
                placeholder: $data.claim_as === 'Company' ? 'company@domain.com' : 'email@domain.com',
                disabled: $data.is_submitted
              }, null, 8 /* PROPS */, _hoisted_41), [
                [_vModelText, $data.formData.email]
              ]),
              _createElementVNode("div", _hoisted_42, [
                ($data.form_error_data.email)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString($data.form_error_data.email), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("label", _hoisted_45, [
                _createElementVNode("span", {
                  textContent: _toDisplayString($data.claim_as === 'Company' ? 'Company Contact No.' : 'Contact No.')
                }, null, 8 /* PROPS */, _hoisted_46),
                _hoisted_47
              ]),
              _createElementVNode("input", {
                id: "phone",
                type: "tel",
                disabled: $data.is_submitted
              }, null, 8 /* PROPS */, _hoisted_48),
              _createElementVNode("div", _hoisted_49, [
                ($data.form_error_data.phone)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString($data.form_error_data.phone), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("label", _hoisted_52, [
                _createElementVNode("span", {
                  textContent: _toDisplayString($data.claim_as === 'Company' ? 'Company Tax Identification No. (TIN)' : 'Tax Identification No. (TIN)')
                }, null, 8 /* PROPS */, _hoisted_53),
                _hoisted_54
              ]),
              _withDirectives(_createElementVNode("input", {
                id: "tax_id",
                type: "text",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.formData.tax_id) = $event)),
                placeholder: "Eg: CXX53644000",
                required: "",
                disabled: $data.is_submitted,
                onInput: _cache[6] || (_cache[6] = $event => ($data.formData.tax_id = $data.formData.tax_id.toUpperCase()))
              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_55), [
                [_vModelText, $data.formData.tax_id]
              ]),
              _createElementVNode("div", _hoisted_56, [
                ($data.form_error_data.tax_id)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString($data.form_error_data.tax_id), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            ($data.claim_as === 'Company')
              ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                  _hoisted_59,
                  _withDirectives(_createElementVNode("input", {
                    id: "roc",
                    type: "text",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($data.formData.roc) = $event)),
                    placeholder: "Eg: 198301031144",
                    required: "",
                    disabled: $data.is_submitted,
                    onInput: _cache[8] || (_cache[8] = $event => ($data.formData.roc = $data.formData.roc.toUpperCase()))
                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_60), [
                    [_vModelText, $data.formData.roc]
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    ($data.form_error_data.roc)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString($data.form_error_data.roc), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            ($data.claim_as === 'Company')
              ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                  _hoisted_64,
                  _withDirectives(_createElementVNode("input", {
                    id: "sst_number",
                    type: "text",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($data.formData.sst_number) = $event)),
                    placeholder: "Eg: XXX8888888888XX",
                    disabled: $data.is_submitted,
                    onInput: _cache[10] || (_cache[10] = $event => ($data.formData.sst_number = $data.formData.sst_number.toUpperCase()))
                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_65), [
                    [_vModelText, $data.formData.sst_number]
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    ($data.form_error_data.sst_number)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_67, _toDisplayString($data.form_error_data.sst_number), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            ($data.claim_as === 'Company' && $data.is_supplier)
              ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                  _hoisted_69,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (($data.formData.msic_code) = $event)),
                    required: "",
                    disabled: $data.is_submitted,
                    id: "msic-code-select-element"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.msic_options, (msic_code, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: msic_code.name
                      }, _toDisplayString(msic_code.name) + " - " + _toDisplayString(msic_code.description), 9 /* TEXT, PROPS */, _hoisted_71))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 8 /* PROPS */, _hoisted_70), [
                    [_vModelSelect, $data.formData.msic_code]
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            ($data.claim_as === 'Company')
              ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                  _hoisted_73,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (($data.formData.fax_number) = $event)),
                    placeholder: "Eg: 123-456-7890",
                    disabled: $data.is_submitted
                  }, null, 8 /* PROPS */, _hoisted_74), [
                    [_vModelText, $data.formData.fax_number]
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            ($data.claim_as === 'Company')
              ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                  _hoisted_76,
                  _withDirectives(_createElementVNode("input", {
                    type: "time",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => (($data.formData.operating_from_time) = $event)),
                    required: "",
                    disabled: $data.is_submitted
                  }, null, 8 /* PROPS */, _hoisted_77), [
                    [_vModelText, $data.formData.operating_from_time]
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            ($data.claim_as === 'Company')
              ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                  _hoisted_79,
                  _withDirectives(_createElementVNode("input", {
                    type: "time",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (($data.formData.operating_to_time) = $event)),
                    required: "",
                    disabled: $data.is_submitted
                  }, null, 8 /* PROPS */, _hoisted_80), [
                    [_vModelText, $data.formData.operating_to_time]
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Sales Representative Info Fields "),
            ($data.claim_as === 'Company')
              ? (_openBlock(), _createElementBlock("div", _hoisted_81, [..._hoisted_83]))
              : _createCommentVNode("v-if", true),
            ($data.claim_as === 'Company')
              ? (_openBlock(), _createElementBlock("hr", _hoisted_84))
              : _createCommentVNode("v-if", true),
            ($data.claim_as === 'Company')
              ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                  _hoisted_86,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => (($data.formData.sales_representative) = $event)),
                    placeholder: "Eg: John Doe",
                    required: "",
                    disabled: $data.is_submitted
                  }, null, 8 /* PROPS */, _hoisted_87), [
                    [_vModelText, $data.formData.sales_representative]
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            ($data.claim_as === 'Company')
              ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                  _hoisted_89,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => (($data.formData.sales_representative_email) = $event)),
                    id: "sales_representative_email",
                    placeholder: "Eg: john.doe@example.com",
                    required: "",
                    disabled: $data.is_submitted
                  }, null, 8 /* PROPS */, _hoisted_90), [
                    [_vModelText, $data.formData.sales_representative_email]
                  ]),
                  _createElementVNode("div", _hoisted_91, [
                    ($data.form_error_data.sales_representative_email)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_92, _toDisplayString($data.form_error_data.sales_representative_email), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            ($data.claim_as === 'Company')
              ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                  _hoisted_94,
                  _createElementVNode("input", {
                    id: "sales_representative_contact_number",
                    type: "tel",
                    disabled: $data.is_submitted
                  }, null, 8 /* PROPS */, _hoisted_95),
                  _createElementVNode("div", _hoisted_96, [
                    ($data.form_error_data.sales_representative_contact_number)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_97, _toDisplayString($data.form_error_data.sales_representative_contact_number), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Accounts Receivable Representative Info Fields "),
            ($data.claim_as === 'Company')
              ? (_openBlock(), _createElementBlock("div", _hoisted_98, [..._hoisted_100]))
              : _createCommentVNode("v-if", true),
            ($data.claim_as === 'Company')
              ? (_openBlock(), _createElementBlock("hr", _hoisted_101))
              : _createCommentVNode("v-if", true),
            ($data.claim_as === 'Company')
              ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                  _hoisted_103,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => (($data.formData.accounts_receivable_representative) = $event)),
                    placeholder: "Eg: Jane Doe",
                    required: "",
                    disabled: $data.is_submitted
                  }, null, 8 /* PROPS */, _hoisted_104), [
                    [_vModelText, $data.formData.accounts_receivable_representative]
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            ($data.claim_as === 'Company')
              ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                  _hoisted_106,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => (($data.formData.accounts_receivable_representative_email) = $event)),
                    id: "accounts_receivable_representative_email",
                    placeholder: "Eg: jane.doe@example.com",
                    required: "",
                    disabled: $data.is_submitted
                  }, null, 8 /* PROPS */, _hoisted_107), [
                    [_vModelText, $data.formData.accounts_receivable_representative_email]
                  ]),
                  _createElementVNode("div", _hoisted_108, [
                    ($data.form_error_data.accounts_receivable_representative_email)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_109, _toDisplayString($data.form_error_data.accounts_receivable_representative_email), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            ($data.claim_as === 'Company')
              ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                  _hoisted_111,
                  _createElementVNode("input", {
                    id: "accounts_receivable_representative_contact_number",
                    type: "tel",
                    disabled: $data.is_submitted
                  }, null, 8 /* PROPS */, _hoisted_112),
                  _createElementVNode("div", _hoisted_113, [
                    ($data.form_error_data.accounts_receivable_representative_contact_number)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_114, _toDisplayString($data.form_error_data.accounts_receivable_representative_contact_number), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Address Fields "),
            _createElementVNode("div", _hoisted_115, [
              _createElementVNode("span", {
                textContent: _toDisplayString($data.claim_as === 'Company' ? 'COMPANY ADDRESS' : 'ADDRESS')
              }, null, 8 /* PROPS */, _hoisted_116)
            ]),
            _hoisted_117,
            _createElementVNode("div", _hoisted_118, [
              _hoisted_119,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => (($data.formData.address_line_1) = $event)),
                placeholder: "NO 123, Jalan Besar",
                required: "",
                disabled: $data.is_submitted
              }, null, 8 /* PROPS */, _hoisted_120), [
                [_vModelText, $data.formData.address_line_1]
              ])
            ]),
            _createElementVNode("div", _hoisted_121, [
              _hoisted_122,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => (($data.formData.address_line_2) = $event)),
                placeholder: $data.is_submitted ? '' : 'Apartment 5A',
                disabled: $data.is_submitted
              }, null, 8 /* PROPS */, _hoisted_123), [
                [_vModelText, $data.formData.address_line_2]
              ])
            ]),
            _createElementVNode("div", _hoisted_124, [
              _hoisted_125,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => (($data.formData.postcode) = $event)),
                placeholder: "12345",
                required: "",
                disabled: $data.is_submitted
              }, null, 8 /* PROPS */, _hoisted_126), [
                [_vModelText, $data.formData.postcode]
              ])
            ]),
            _createElementVNode("div", _hoisted_127, [
              _hoisted_128,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => (($data.formData.country) = $event)),
                required: "",
                disabled: $data.is_submitted
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.country_options, (country) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: country.name,
                    value: country.name
                  }, _toDisplayString(country.name), 9 /* TEXT, PROPS */, _hoisted_130))
                }), 128 /* KEYED_FRAGMENT */))
              ], 8 /* PROPS */, _hoisted_129), [
                [_vModelSelect, $data.formData.country]
              ])
            ]),
            _createElementVNode("div", _hoisted_131, [
              _hoisted_132,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => (($data.formData.state_code) = $event)),
                required: "",
                disabled: $data.is_submitted || $data.formData.country != 'Malaysia'
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filtered_state_options, (state_code) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: state_code.name,
                    value: state_code.name
                  }, _toDisplayString(state_code.name) + " - " + _toDisplayString(state_code.state), 9 /* TEXT, PROPS */, _hoisted_134))
                }), 128 /* KEYED_FRAGMENT */))
              ], 8 /* PROPS */, _hoisted_133), [
                [_vModelSelect, $data.formData.state_code]
              ])
            ]),
            _createElementVNode("div", _hoisted_135, [
              _hoisted_136,
              ($data.formData.country != 'Malaysia')
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    type: "text",
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => (($data.formData.city) = $event)),
                    placeholder: "Enter city",
                    required: "",
                    disabled: $data.is_submitted
                  }, null, 8 /* PROPS */, _hoisted_137)), [
                    [_vModelText, $data.formData.city]
                  ])
                : ($data.formData.state_code)
                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                      key: 1,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => (($data.formData.city) = $event)),
                      required: "",
                      disabled: $data.is_submitted
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.set_cities($data.formData.state_code), (city, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: index,
                          value: city
                        }, _toDisplayString(city), 9 /* TEXT, PROPS */, _hoisted_139))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 8 /* PROPS */, _hoisted_138)), [
                      [_vModelSelect, $data.formData.city]
                    ])
                  : (_openBlock(), _createElementBlock("select", _hoisted_140, [..._hoisted_142]))
            ]),
            _createElementVNode("div", _hoisted_143, [
              _createElementVNode("button", {
                type: "submit",
                class: _normalizeClass(["btn-primary", { 'btn-success': $data.is_submitted }]),
                disabled: $data.is_submitting || $data.is_submitted,
                style: {"border-radius":"2rem","font-weight":"bold"}
              }, _toDisplayString($data.is_submitted ? "Submitted" : ($data.is_submitting ? "Submitting..." : "Submit")), 11 /* TEXT, CLASS, PROPS */, _hoisted_144)
            ])
          ], 32 /* NEED_HYDRATION */),
          _createElementVNode("div", _hoisted_145, [
            _createTextVNode(" Powered by "),
            _createElementVNode("a", {
              href: `https://www.byondwave.com/`,
              target: "_blank",
              style: {"color":"#398bff"}
            }, "BYONDWAVE.com", 8 /* PROPS */, _hoisted_146)
          ])
        ])
      ]))
}